import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/param_schemes'
export default {
  namespaced: true,
  state: {
    paramGroups: [],
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      param_groups: null,
      param_sub_groups: null,
      notes: null,
      str_value_1: null,
      str_value_2: null,
      str_value_3: null,
      int_value_1: null,
      int_value_2: null,
      int_value_3: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    paramGroups(state) {
      return state.paramGroups
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_PARAM_GROUPS(state, data) {
      state.paramGroups = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        param_groups: null,
        param_sub_groups: null,
        notes: null,
        str_value_1: null,
        str_value_2: null,
        str_value_3: null,
        int_value_1: null,
        int_value_2: null,
        int_value_3: null,
        id_users: null,
      }
    },
  },
  actions: {
    getParamGroups({ commit }) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify({
        select: [
          'param_schemes.id AS id',
          'param_schemes.param_groups AS param_groups',
          'param_schemes.param_sub_groups AS param_sub_groups',
          'param_schemes.notes AS notes',
        ],
        group_by: 'param_schemes.param_sub_groups',
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_PARAM_GROUPS', response.data.data)
        })
        .catch(error => console.error(error))
    },
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify({
        where: {
          'param_schemes.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
